import ModalFrameHoc from 'components/Modal/modalFrameHoc'
import { Button, Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styles from 'modules/Modals/Confirmation/confirmationmodal.module.scss'

const ConfirmationModal = (props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { submitting, UUID, title, text, buttons = {}, closeModal } = props
  const { attention = false } = buttons

  const cancel = useCallback(() => {
    dispatch({ type: 'MODAL/CANCEL_' + UUID })
  }, [UUID, dispatch])

  const approve = useCallback(() => {
    dispatch({ type: 'MODAL/CONFIRM_' + UUID })
  }, [dispatch, UUID])

  const close = useCallback(() => {
    cancel()
    closeModal()
  }, [])

  return (
    <ModalFrameHoc {...props} closeModal={close} title={t(title)}>
      <Grid direction={'column'} gap={32}>
        {!!text && (
          <div
            className={styles['confirmation-modal__text']}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
        <Grid
          gap={16}
          direction={'column-reverse'}
          fb={{
            direction: 'row',
          }}
          justifyContent={'between'}
          className={styles['confirmation-modal__button-container']}
        >
          <Button
            onClick={cancel}
            color={'Label-Fifth'}
            variant="default"
            disabled={submitting}
          >
            {buttons.cancel || t('common::confirmation_modal.cancel')}
          </Button>

          <Button
            variant={attention ? 'error' : 'primary'}
            onClick={approve}
            disabled={submitting}
          >
            {buttons.apply || t('common::confirmation_modal.apply')}
          </Button>
        </Grid>
      </Grid>
    </ModalFrameHoc>
  )
}

export default ConfirmationModal

ConfirmationModal.propTypes = {
  submitting: PropTypes.bool,
  UUID: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  buttons: PropTypes.object,
  closeModal: PropTypes.func,
}
